import { createFileRoute } from '@tanstack/react-router'
import { LcrPage } from '@/features/admin/lcr/pages/lcr-page'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/lcr/')({
  component: LcrPage,
  beforeLoad: requireRole(['admin']),
})
